import { getField, updateField } from "vuex-map-fields";

const getDefaultState = () => {
  return {
    //전계좌조회
    RBF0404F40: {},

    //Push설정정보조회
    RBF0404M40: {
      in: {
        userIndfr: "",
      },
      out: {},
    },
    //Push설정정보등록
    RBF0604M60: {
      in: {
        inputParamCommon: {
          pushRecvCnsntYn: "",
          rcdrwCnsntYn: "",
          prdctCnsntYn: "",
          anounCnsntYn: "",
          motpAuthCnsntYn: "",
          aprvalCnsntYn: "",
          gridRowCnt: 0,
          dataGrid: [],
        },
      },
      out: {},
    },

    pushNotiStupInfo: {
      pushRecvCnsntYn: "",
      rcdrwCnsntYn: "",
      prdctCnsntYn: "",
      anounCnsntYn: "",
      motpAuthCnsntYn: "",
      aprvalCnsntYn: "",
      lvbdInfoCnsntYn: "",
      gridRowCnt: 0,
      dataGrid: [],
    },
    pushNotiAcnoStupInfo: {
      totalCnt: 0,
      acnoCnt: 0,
      dataGrid: [],
    },
  };
};

const pushNotiStup = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    getField,
    getPushNotiStupInfo: state => {
      return state.pushNotiStupInfo;
    },
    getPushNotiAcnoStupInfo: state => {
      return state.pushNotiAcnoStupInfo;
    },
  },
  mutations: {
    updateField,
    resetState: state => {
      Object.assign(state, getDefaultState());
    },
    setRBF0470140_init: state => {
      state.RBF0470140 = getDefaultState().RBF0470140;
    },
    setRBF0404M40: (state, payload) => {
      state.RBF0404M40 = payload;
    },
    setRBF0604M60: (state, payload) => {
      state.RBF0604M60 = payload;
    },
    setPushNotiStupInfo_init: state => {
      state.pushNotiStupInfo = getDefaultState().pushNotiStupInfo;
    },
    setPushNotiStupInfo: (state, payload) => {
      state.pushNotiStupInfo = payload;
    },
    setPushNotiAcnoStupInfo_init: state => {
      state.pushNotiAcnoStupInfo = getDefaultState().pushNotiAcnoStupInfo;
    },
    setPushNotiAcnoStupInfo: (state, payload) => {
      state.pushNotiAcnoStupInfo = payload;
    },
  },
  actions: {
    //Push설정정보 init
    ACT_setPushNotiStupInfo_init: context => {
      context.commit("setPushNotiStupInfo_init");
    },
    //Push설정정보 Set
    ACT_setPushNotiStupInfo: (context, payload) => {
      context.commit("setPushNotiStupInfo", payload);
    },

    //Push설정계좌정보 init
    ACT_setPushNotiAcnoStupInfo_init: context => {
      context.commit("setPushNotiAcnoStupInfo_init");
    },
    //Push설정계좌정보 Set
    ACT_setPushNotiAcnoStupInfo: (context, payload) => {
      context.commit("setPushNotiAcnoStupInfo", payload);
    },
  },
};

export default pushNotiStup;
